module.exports = __webpack_public_path__ + "img/S2.1958a86e.png";